import { faCalendarDay, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import ModalSelectPerson from "./ModalSelectPerson";
import { keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import { CheckLg, List } from "react-bootstrap-icons";
import { getEventTypeListWithCallback } from "../../CRM/store/api/CustomerApi";
import { addNewEvent } from "../../CRM/store/api/CustomerApi";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";

const ModalAddNewEvent = (props) => {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const [eventData, setEventData] = useState({});
    const [pending, setPending] = useState(false);
    const [modalPerson, setModalPerson] = useState({ show: false });
    const [typeList, setTypeList] = useState([]);
    const { handleSubmit, register, errors } = useForm();
    const { show, onAdd } = popData;
    function close() {
        setPopData({
            show: false
        })
    }
    function addEvent(data) {
        setPending(true);
        const onSuccess = (res) => {
            setEventData({});
            setPending(false);
            setPopData({
                show: false
            })
            if (onAdd) {
                onAdd(res);
            }
        }
        const pNextDate = document.getElementsByName("NextDate")[0].value;
        if (pNextDate !== "") {
            data.NextDate = eventData.NextDate;
        }
        data.IsPreCustomer = eventData.IsPreCustomer;
        data.IsStaff = eventData.IsStaff;
        dispatch(addNewEvent(data, onSuccess));
    }
    function showModalPerson(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
        }
        const onSelect = (p) => {
            setEventData({
                ...eventData,
                CustomerID: p.ID,
                CustomerName: p.PersonName,
                IsStaff: p.PersonType === "Staff" || p.PersonType === "Agent",
                IsPreCustomer: p.PersonType === "PreCustomer"
            })
        }
        setModalPerson({
            show: true,
            onSelect: onSelect
        })
    }
    useEffect(() => {
        if (show && (!typeList || typeList.length === 0)) {
            getEventTypeListWithCallback(setTypeList);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }} size="lg">
            <ModalSelectPerson popData={modalPerson} setPopData={setModalPerson} />
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCalendarDay} size="lg" />&nbsp;
                    تعریف رویداد
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form onSubmit={handleSubmit(addEvent)}>
                    <Row>
                        <Col md={4} className="form-group">
                            <label>طرف رویداد: </label>
                            <input type="hidden" value={eventData.CustomerID} name="CustomerID" ref={register({ required: true })} />
                            <Form.Control value={eventData.CustomerName} readOnly onKeyDown={showModalPerson} />
                            <Button className="btn-input-tiny" onClick={showModalPerson}><List size={20} /></Button>
                            {errors.CustomerID && <small className="errors">انتخاب طرف رویداد الزامی است</small>}
                        </Col>
                        <Col md={3} className="form-group">
                            <label>نوع رویداد: </label><span style={{ color: "red", fontSize: "14px" }}>*</span>
                            <select className="form-control" name="EventTypeID" ref={register({ required: true })}>
                                <option value="">انتخاب کنید</option>
                                {typeList && Array.isArray(typeList) &&
                                    typeList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                            </select>
                            {errors.EventTypeID && <small className="errors">نوع رویداد الزامی است</small>}
                        </Col>
                        <Col md={3} className="form-group">
                            <label>تاریخ پیگیری: </label>
                            <DatePicker name="NextDate" isGregorian={false} timePicker={false} className="form-control"
                                onChange={value => setEventData({ ...eventData, NextDate: value.local("en").format("YYYY/MM/DD") })} />
                        </Col>
                        <Col md={7} className="form-group">
                            <label>شرح رویداد</label><span style={{ color: "red", fontSize: "14px" }}>*</span>
                            <Form.Control name="Description" ref={register({ required: true })} />
                            {errors.Description && <small className="errors">شرح رویداد الزامی است</small>}
                        </Col>

                    </Row>
                    <Button variant="success" type="submit" className="group-Btn mt-2">
                        {!pending && <Fragment><CheckLg />&nbsp;ثبت رویداد</Fragment>}
                        {pending && <Fragment> <Loader type="BallTriangle" color="white" height={15} width={15} style={{ display: "inline-block" }} />&nbsp; منتظر بمانید</Fragment>}
                    </Button>
                </form>
            </Modal.Body>
        </Modal>
    )

}
export default ModalAddNewEvent;